<template>
  <div class="card-body">
    <p class="card-text">{{cardTitle}}</p>
    <h6 class="card-title">{{cardNumbers}}</h6>
    <p class="card-text">
      <small :class="metadata">{{cardMeta}}</small>
    </p>
  </div>
</template>

<script>
export default {
  name: "infocards",
  props: ["cardTitle", "cardNumbers", "cardMeta"],
  computed: {
    metadata: function() {
      if (this.cardMeta.includes("more") === true) {
        return "text-success";
      } else if (this.cardMeta.includes("less") === true) {
        return "text-danger";
      }
    }
  }
};
</script>

<style scoped>
.info-card {
  height: 120px;
}
</style>
